import { useEffect, useRef, useState } from 'react'

type SalesForceProps = {
  content: {
    formStyle?: string
    formScript?: string
    formURL?: string
  }
}

let scriptLoaded = false
let styleLoaded = false
let customScriptLoaded = false

const SalesForce = ({ content }: SalesForceProps) => {
  const { formStyle, formScript } = content || {}

  const [isVisible, setIsVisible] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const styleRef = useRef<HTMLStyleElement | null>(null)
  const customScriptRef = useRef<HTMLScriptElement | null>(null)

  // console.log('form:', formURL)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      { threshold: 0.1 }
    )
    if (containerRef.current) {
      observer.observe(containerRef.current)
    }
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    let lightningScript: HTMLScriptElement | null = null

    if (isVisible && !scriptLoaded) {
      lightningScript = document.createElement('script')
      lightningScript.src =
        'https://hull.lightning.force.com/lightning/lightning.out.js'
      lightningScript.type = 'text/javascript' // <-- FIXED HERE
      lightningScript.async = true
      lightningScript.onload = () => {
        // Inject custom styles from props
        if (formStyle && !styleLoaded) {
          const style = document.createElement('style')
          style.textContent = formStyle
          document.head.appendChild(style)
          styleRef.current = style
          styleLoaded = true
        }

        // Inject custom script from props AFTER Lightning script loads
        if (
          formScript &&
          typeof formScript === 'string' &&
          formScript.trim().length > 0 &&
          !customScriptLoaded
        ) {
          const customScript = document.createElement('script')
          customScript.type = 'text/javascript'
          customScript.text = formScript
          document.body.appendChild(customScript)
          customScriptRef.current = customScript
          customScriptLoaded = true
        }
      }
      document.body.appendChild(lightningScript)
      scriptLoaded = true
    }

    // Cleanup
    return () => {
      if (lightningScript) {
        document.body.removeChild(lightningScript)
        scriptLoaded = false
      }
      if (styleRef.current) {
        document.head.removeChild(styleRef.current)
        styleLoaded = false
      }
      if (customScriptRef.current) {
        document.body.removeChild(customScriptRef.current)
        customScriptLoaded = false
      }
    }
  }, [isVisible, formStyle, formScript])

  return <div ref={containerRef} id='form-container'></div>
}

export default SalesForce
